import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import Icon from '../common/containers/icon';
export const CABINET_COLUMN_DND_TYPE = 'CABINET_COLUMN_FIELD';
const SWITCH_COLUMN_STYLE = {
  width: '2.75rem',
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
};
const FieldSwitch = _ref => {
  let id = _ref.id,
    checked = _ref.checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? undefined : _ref$onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "t-col-customizer-switch-col",
    style: SWITCH_COLUMN_STYLE
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check form-switch mb-0",
    style: {
      paddingLeft: 0,
      marginBottom: 0,
      minHeight: '1.25rem'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    role: "switch",
    id: id,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    style: {
      cursor: disabled ? 'default' : 'pointer',
      marginLeft: 0,
      float: 'none'
    }
  })));
};
export const fieldRowLayoutClass = 't-col-customizer-field-row d-flex align-items-center px-3 py-2';
export const fieldRowLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  minWidth: 0,
  marginRight: '0.5rem',
  gap: '0.5rem'
};
export const fieldRowHandleStyle = {
  width: '1.25rem',
  flexShrink: 0
};
FieldSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};
const CabinetColumnCustomizerDraggableRow = _ref2 => {
  let fieldKey = _ref2.fieldKey,
    title = _ref2.title,
    index = _ref2.index,
    onOrderChange = _ref2.onOrderChange,
    onToggleOff = _ref2.onToggleOff;
  const ref = useRef(null);
  const _useDrop = useDrop({
      accept: CABINET_COLUMN_DND_TYPE,
      collect: monitor => ({
        handlerId: monitor.getHandlerId()
      }),
      hover(item, monitor) {
        if (!ref.current) {
          return;
        }
        const dragIndex = item.index;
        const hoverIndex = index;
        if (dragIndex === hoverIndex) {
          return;
        }
        const hoverBoundingRect = ref.current.getBoundingClientRect();
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        if (!clientOffset) {
          return;
        }
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
        onOrderChange(dragIndex, hoverIndex);
        // eslint-disable-next-line no-param-reassign
        item.index = hoverIndex;
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    handlerId = _useDrop2[0].handlerId,
    drop = _useDrop2[1];
  const _useDrag = useDrag({
      type: CABINET_COLUMN_DND_TYPE,
      item: () => ({
        key: fieldKey,
        index
      }),
      collect: monitor => ({
        isDragging: monitor.isDragging()
      })
    }),
    _useDrag2 = _slicedToArray(_useDrag, 2),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1];
  drag(drop(ref));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-handler-id": handlerId,
    "data-testid": "t-col-customizer-shown-".concat(fieldKey),
    className: fieldRowLayoutClass,
    style: {
      opacity: isDragging ? 0.4 : 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: fieldRowLabelStyle
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-col-customizer-drag-handle text-muted",
    style: _objectSpread(_objectSpread({}, fieldRowHandleStyle), {}, {
      cursor: 'grab'
    }),
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "bars"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-truncate"
  }, title)), /*#__PURE__*/React.createElement(FieldSwitch, {
    id: "t-col-customizer-switch-".concat(fieldKey),
    checked: true,
    onChange: () => onToggleOff(fieldKey)
  }));
};
CabinetColumnCustomizerDraggableRow.propTypes = {
  fieldKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  onToggleOff: PropTypes.func.isRequired
};
export { FieldSwitch };
export default CabinetColumnCustomizerDraggableRow;